import escape from "escape-html"
import iziToast from "izitoast"

import checkIcon from "$icons/check.svg"
import crossIcon from "$icons/times.svg"

function toast (message, color, iconUrl, buttons = []) {
  iziToast.show({
    message: `<div style="white-space: pre-line">${escape(message)}</div>`,
    color,
    progressBar: false,
    iconUrl,
    buttons,
  })
}

export function alertSuccess (message, buttons) {
  toast(message, "green", checkIcon, buttons)
}

export function alertFailure (message) {
  toast(message, "red", crossIcon)
}
